// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/layout/pioneer/PioneerSidebar.module.css';

/** The Pioneerlands orbit mark, drawn in the current text colour. */
export function PioneerlandsMark({className}: {className?: string}) {
	return (
		<svg
			className={className ?? styles.mark}
			viewBox="0 0 1000 1000"
			aria-hidden="true"
			data-flx="app.pioneer.pioneerlands-mark.svg"
		>
			<mask
				id="pioneer-mark-front"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="1000"
				height="1000"
				data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.pioneer-mark-front"
			>
				<rect width="1000" height="1000" fill="#fff" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.rect" />
				<g fill="#000" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.g">
					<path
						d="M282.5 729.2A640 640 0 0 1 348 540A640 640 0 0 1 745.6 301.1"
						fill="none"
						stroke="#000"
						strokeWidth="78"
						data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.path"
					/>
					<circle cx="745.6" cy="301.1" r="85" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle" />
					<circle cx="348" cy="540" r="85" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle--2" />
					<circle cx="282.5" cy="729.2" r="85" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle--3" />
				</g>
			</mask>
			<g
				fill="none"
				stroke="currentColor"
				strokeWidth="44"
				mask="url(#pioneer-mark-front)"
				data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.g--2"
			>
				<circle cx="500" cy="500" r="316" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle--4" />
				<ellipse
					cx="517.4"
					cy="478.6"
					rx="309.6"
					ry="175"
					transform="rotate(50.1 517.4 478.6)"
					data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.ellipse"
				/>
			</g>
			<path
				d="M282.5 729.2A640 640 0 0 1 348 540A640 640 0 0 1 745.6 301.1"
				fill="none"
				stroke="currentColor"
				strokeWidth="44"
				data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.path--2"
			/>
			<g fill="currentColor" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.g--3">
				<circle cx="318.7" cy="241.1" r="72" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle--5" />
				<circle cx="745.6" cy="301.1" r="72" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle--6" />
				<circle cx="348" cy="540" r="72" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle--7" />
				<circle cx="282.5" cy="729.2" r="72" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle--8" />
				<circle cx="716" cy="716" r="72" data-flx="app.pioneer.pioneer-top-bar.pioneerlands-mark.circle--9" />
			</g>
		</svg>
	);
}
